function resolveLineColor(style, darkMode) {
  return darkMode === "dark" ? style.lineColorDarkMode : style.lineColor;
}
function resolveFillColor(style, darkMode) {
  return darkMode === "dark" ? style.fillColorDarkMode : style.fillColor;
}
function resolveMarkerColor(style, darkMode) {
  return darkMode === "dark" ? style.markerColorDarkMode : style.markerColor;
}
function resolveHandleColor(darkMode) {
  return darkMode === "dark" ? "#b0b0b0" : "#404040";
}
function resolveCanvasColor(darkMode) {
  return darkMode === "dark" ? "#121212" : "white";
}
export {
  resolveLineColor as a,
  resolveCanvasColor as b,
  resolveMarkerColor as c,
  resolveHandleColor as d,
  resolveFillColor as r
};
